import React, { useState } from "react";
import "./sign-in.styles.scss";
import FormInput from "../../../general/form-input/form-input.component";
import Button from "../../../general/button/button.component";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import db from "../../../../firebase.config";
import { collection, query, where, getDocs } from "firebase/firestore";
var bcrypt = require("bcryptjs");

let isLoggedIn = false;
let studentUSN = '';
let incorrectPassword = false;
const finalList = []; //global variable for next page

const dataRetriever = async (email) => {
  const allStudentsRef = collection(db, "studentData");
  const queriedResult1 = query(allStudentsRef, where("email", "==", email));
  // const queriedResult2 = query(queriedResult1, where(where("twelfthper", ">=", (twelfthper))));
  // const queriedResult3 = query(queriedResult2, where(("UGCGPA", ">=", (UGCGPA))));
  const docsSnapshot = await getDocs(queriedResult1);
  docsSnapshot.forEach((doc) => {
    // doc.data() is never undefined for query doc snapshots
    finalList.push(doc.data());
  });
  return finalList[0];
};

const SignIn = (props) => {
  let navigate = useNavigate();
  const [state, setState] = useState({
    email: "",
    password: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(state);
    const { email, password } = state;

    dataRetriever(email).then((response) => {
      const passComp = bcrypt.compareSync(password, response.password);
      studentUSN = response.USN;
      if (!response) incorrectPassword = true;
      if (response.role === "student") {
        if (props.buttonLink !== "dashboard/student" && passComp) {
          isLoggedIn = true;
          navigate("../../../dashboard/student");
        } else incorrectPassword = true;
      } else if (response.role === "faculty") {
        console.log(response.password, bcrypt.hashSync(password, 8));
        if (props.buttonLink === "dashboard/faculty" && passComp) {
          isLoggedIn = true;
          navigate("../../../dashboard/faculty", { replace: true });
        } else {
          incorrectPassword = true;
        }
      } else navigate("../../../notfound");
    });
  };
  const handleChange = (e) => {
    const { value, name } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const heading = props.secondSignText
    ? props.secondSignText
    : props.firstSignText;

  return (
    <div className="sign-in">
      <Typography
        variant="h5"
        sx={{ fontFamily: "Montserrat" }}
        className="title"
      >
        {heading}
      </Typography>
      <Typography variant="sub">Sign in with email and password</Typography>
      <form onSubmit={handleSubmit}>
        <FormInput
          name="email"
          type="email"
          value={state.email}
          required
          onChange={handleChange}
          label="Email"
          placeholder="Email Address"
        />
        <FormInput
          name="password"
          type="password"
          value={state.password}
          required
          onChange={handleChange}
          label="Password"
          placeholder="Password"
        />
        <Button type="submit" onClick={handleSubmit}>
          Sign in
        </Button>
      </form>
      <Typography variant="sub">
        {incorrectPassword ? "Password or email incorrect" : null}
      </Typography>
    </div>
  );
};
export default SignIn;
export { isLoggedIn, studentUSN };
